export default {"src":"/_next/static/media/icon_chat_accept_friend.343873ae.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};